<template>
  <div class='core'>
    <div class='layui-fluid'>
      <pub-search
        :search-type="'add'"
        :tableObj='tableObj'
        :searchConfig='searchConfig'
        exportType="1"
      >
      </pub-search>
      <layui-table
        ref='systemConfigRef'
        table-name='SYS_CONFIG'
        :page-size='20'
        :page-range='6'
        :page-options='[10, 20, 50, 100]'
        :skin="'line'"
      >
        <div>
          <div field="FUNCTION_LET_NAME" width="200" title="模块名称"></div>
          <div field="BUSINESS_NAME" title="业务名称"></div>
          <div field="TABLE_NAME" width="200" title="表名"></div>
          <div field="B_ENABLED" width="200" title="是否启用">
            <script type="text/html" id="switchTpl" v-pre>
              <input type="checkbox" name="B_ENABLED" value="{{d.B_ENABLED}}" data-id="{{ d.ID }}" lay-skin="switch"
                     lay-text="开启|关闭" lay-filter="switchFilter" {{ d.B_ENABLED == '1' ? 'checked' : '' }}>
            </script>
          </div>
          <div field="MEMO" title="备注"></div>
        </div>
      </layui-table>

    </div>
  </div>
</template>
<script>
import "../../../utils/map/css/core.css"

export default {
  name: 'storeManagerManage',
  data () {
    return {
      tableObj: {
        checkedRows: 0,
        queryObject: {}
      },
      searchConfig: {
        basic: [
          {
            TYPE: 'input',
            WIDTH: 260,
            FIELD: 'BUSINESS_NAME:2, TABLE_NAME:2, FUNCTION_LET_NAME:2',
            PLACEHOLDER: '请输入查询条件'
          }
        ],
        showBatch: false
      },
    }
  },
  mounted(){
    this.tableObj = this.$refs.systemConfigRef;

    this.layui.form.on('switch(switchFilter)', (obj) => {
      let title = obj.elem.checked ? '开启' : '关闭';
      this.layer.openConfirm('确定要' + title + "吗？", ()=> {
        let editRow = {IS_NEW: false};
        editRow['ID'] = obj.elem.dataset.id;
        editRow.B_ENABLED = obj.elem.checked ? '1' : '0';

        this.api.save('SYS_CONFIG', editRow,  'SYS_CONFIG_REQUEST').then(response => {
          if(response.errorMsg) {
            this.layer.openAlert(response.errorMsg, false);
          } else {
            this.layer.openSuccess(title + '成功!');
            this.tableObj.pageInfo.pageIndex = 1;
            this.tableObj.load();
          }
        });
      }, () => {this.tableObj.load();});
    });
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/ywpt/systemconfig/KFConfig.vue